const getters = {
  themeImg: state => state.setttings.themeImg,
}
export default getters